import { addLocale } from "primereact/api";
import { Row } from "react-bootstrap";
import { useState } from "react";
import Dialog from "../../components/Dialog";
import InputLabelTextArea from "../../components/InputLabelTextArea";
import { ptBrDatepickerTranslations } from "../../i18n/locales/pt-br";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import {
    StyledInfoLabel,
    StyledInfoText,
} from "../../styles/pages/Schedule/ModalViewDetailsStyles";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const { StyledModalTitle } = DialogStyles;

interface IModalProps {
    open: boolean;
    onClose?: (callback?: any) => void;
    onSave: (callback?: any) => void;
}

const ModalJustificativa: React.FC<IModalProps> = ({
    open,
    onClose,
    onSave,
}) => {
    const [justificativa, setJustificativa] = useState("");
    const [isConfirm, setIsConfirm] = useState(false);

    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            size="width-700 modal-white modal-radius-8"
        >
            <StyledModalTitle className="mb-3">
                Indeferir abono legal
            </StyledModalTitle>
            <StyledInfoText>
                Deixe abaixo a justificativa para indeferir o abono solicitado
            </StyledInfoText>
            <div style={{ height: 20 }} />
            <StyledInfoLabel>Justificativa</StyledInfoLabel>
            {!isConfirm ? (
                <InputLabelTextArea
                    value={justificativa}
                    placeholder="Insira sua justificativa"
                    onChange={(event: any) =>
                        setJustificativa(event.target.value as string)
                    }
                    viewLengthInfo
                    maxLength={500}
                    style={{
                        height: "107px",
                        borderStyle: "solid",
                        borderColor: "#787878",
                    }}
                />
            ) : (
                <StyledInfoText>{justificativa}</StyledInfoText>
            )}
            <Row style={{ justifyContent: "center" }}>
                <BtnPrimary
                    disabled={justificativa.length === 0}
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        if (justificativa.length > 0) {
                            if (!isConfirm) {
                                setIsConfirm(true);
                            } else {
                                onSave(justificativa);
                            }
                        }
                    }}
                >
                    Indeferir
                </BtnPrimary>
                <div style={{ height: 15 }} />
                <Row style={{ justifyContent: "center" }}>
                    <DefaultButtonLink
                        onClick={() => {
                            onClose?.();
                        }}
                    >
                        Cancelar
                    </DefaultButtonLink>
                </Row>
            </Row>
        </Dialog>
    );
};

export default ModalJustificativa;
